import React from 'react';

// Source icon — inline so the section carries no image dependency.
const SourceIcon = () => (
    <svg width="12" height="12" viewBox="0 0 16 16" fill="none" aria-hidden="true">
        <circle cx="8" cy="8" r="6.4" stroke="currentColor" strokeWidth="1.3" />
        <path d="M1.6 8h12.8M8 1.6c1.7 1.8 2.6 4 2.6 6.4S9.7 12.6 8 14.4C6.3 12.6 5.4 10.4 5.4 8S6.3 3.4 8 1.6Z" stroke="currentColor" strokeWidth="1.3" strokeLinejoin="round" />
    </svg>
);

// Colours, copy and per-card value sizing taken from the homepage design.
const ODDS = [
    { color: '#F4D03F', lead: true, value: <>We <em>all</em> think we can outperform the market!</> },
    { color: '#F0656E', title: '90% of startups fail', value: '90%', size: 21, source: 'Startup Genome' },
    { color: '#4ECDA0', title: '% startups that get vc funding', value: '0.05%', size: 18, source: 'CB Insights' },
    { color: '#7C8CF0', title: "vc-backed startups that don't return money", value: '75%', size: 21, source: 'Failory' },
    { color: '#C87CE8', title: 'Number of UK exits suffering a price chip', value: '60%', size: 21, source: 'Bizma' },
    { color: '#F5A45C', title: 'The proportion of VCs that do not raise a second fund', value: '>50%', size: 19, source: 'Pitchbook' },
];

const HomeOddsSection = () => (
    <section className="lp-odds">
        <div className="lp-odds-inner">
            <div className="lp-odds-grid">
                {ODDS.map((o, i) => (
                    <div
                        className={`lp-odds-card${o.lead ? ' is-lead' : ''}`}
                        key={i}
                        style={{ background: o.color }}
                        data-lp-reveal
                        data-lp-delay={120 + i * 70}
                    >
                        {o.lead ? (
                            <div className="circle circle--lead"><p className="lead-txt">{o.value}</p></div>
                        ) : (
                            <>
                                <h3 className="hd">{o.title}</h3>
                                <div className="mid">
                                    <div className="circle"><span className="val" style={{ fontSize: `${o.size}px` }}>{o.value}</span></div>
                                </div>
                                <p className="src">🌐 <strong>Source:</strong> <em>{o.source}</em></p>
                            </>
                        )}
                    </div>
                ))}
            </div>
            <p className="lp-odds-caption">Whoever you are we give you the tools to beat these odds</p>
        </div>
    </section>
);

export default HomeOddsSection;
